import { apiPaths } from 'const';
import { serializeQueryParams } from 'utils';

import { mainApi } from './impl';
import {
  IPostProforientationEventApplication,
  IProfessionProforientationData,
  IProfessionProforientationResponse,
  IProforientaitonRecommendationEvents,
  IProforientationRecommendatonApplications,
  IResponsePayload,
} from './types';

export const getProforientationToken = () =>
  mainApi.get<IResponsePayload<string>>(`/external/proforientation/authentication`);

export const getProforientationRecommendationEvents = (personId: string, classLevel: number) =>
  mainApi.get<IResponsePayload<IProforientaitonRecommendationEvents>>(
    `${apiPaths.STUDENT}/${personId}/proforientation/recommendation/event${serializeQueryParams({ classLevel })}`,
  );

export const getProforientationRecommendationApplications = (personId: string) =>
  mainApi.get<IResponsePayload<IProforientationRecommendatonApplications>>(
    `${apiPaths.STUDENT}/${personId}/proforientation/recommendation/status`,
  );

export const postProforientationEventApplication = (personId: string, eventId: string) =>
  mainApi.post<IPostProforientationEventApplication, void>(
    `${apiPaths.STUDENT}/proforientation/recommendation/${personId}`,
    { eventId },
  );

export const getProforientationResults = (personId: string) =>
  mainApi.get<IProfessionProforientationResponse<IProfessionProforientationData>>(
    `${apiPaths.STUDENT}/${personId}/proforientation/getResults`,
  );

export const getProforientationReport = (personId: string) =>
  mainApi.post<null, void>(`${apiPaths.STUDENT}/${personId}/proforientation/report`, null);
